import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../01_atoms/Button';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBTextGrid = ({
  items,
  numbered = false,
  limit = null,
  behaviorSettings = null,
  uuid = null,
}) => {
  const [isVisible, setVisible] = useState(false);
  const classes = [
    'bb',
    'bb-text-grid',
    styles['bb-text-grid'],
    numbered && styles['numbered'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid}>
      <div className="container">
        {items && !!items.length && (
          <ol className={styles['bb-text-grid-items']}>
            {items.map((item, index) => (
              <li
                key={index}
                className={limit && !isVisible && index >= limit ? styles['mobile-hide'] : ''}
              >
                <div className={styles['bb-text-grid-top']}>
                  {!!numbered && <div className={styles['bb-text-grid-number']}>{index + 1}</div>}
                  {item.title && <h2 className={styles['bb-text-grid-heading']}>{item.title}</h2>}
                </div>
                <FormattedText className={styles['bb-text-grid-text']} text={item.text} />
              </li>
            ))}

            {!!limit && items.length > limit && (
              <li className={styles['more-button']}>
                <Button
                  type="secondary"
                  isOutlined={true}
                  isBlock={true}
                  onClick={() => setVisible(!isVisible)}
                  onKeyPress={() => setVisible(!isVisible)}
                >
                  {isVisible ? `Show less` : `Show all (${items.length})`}
                </Button>
              </li>
            )}
          </ol>
        )}
      </div>
    </div>
  );
};

BBTextGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
    }),
  ).isRequired,
  numbered: PropTypes.bool,
  limit: PropTypes.number,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBTextGrid;
